import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  MigrationServicePicker,
  MigrationServicePickerSchema,
} from './MigrationServicePicker';

export const MigrationServicePickerExtension = FormFieldBlueprint.make({
  name: 'MigrationServicePicker',
  // FormFieldBlueprint takes params as a PLAIN OBJECT. (ApiBlueprint is the
  // odd one out and needs the callback form.)
  params: {
    field: async () =>
      createFormField({
        name: 'MigrationServicePicker',
        component: MigrationServicePicker,
        schema: MigrationServicePickerSchema,
      }),
  },
});
